<template>
  <div>
    <PageAppBar>{{title}}</PageAppBar>
    <div class="page-content header-clear-small">
      <div v-if="loading" class="text text-center">
        <mushonga></mushonga>
      </div>
      <div v-else>
        <div class="card card-style preload-img" data-src="images/pictures/27t.jpg" style="height: 250px; background-image: url(&quot;images/pictures/27t.jpg&quot;);">
          <div class="card-center text-center">
            <i class="fa fa-circle-notch fa-5x color-white"></i>
            <h1 class="color-white mt-4">{{ farming.project }}</h1>
            <p class="color-white font-12 mt-n2 mb-5">{{ farming.details }}</p>
          </div>
          <div class="card-overlay bg-black opacity-80"></div>
        </div>
        <div class="card card-style">
          <div class="content mb-2">
            <h3>Details</h3>
            <p v-if="joined" class="color-highlight font-12 mt-n2 mb-2">{{ message }}</p>
            <p>
            <span>
              <i v-for="contribution in farming.my_contributions" :key="contribution.id" class="fa fa-star color-yellow1-dark"></i>
            </span>
            </p>
            <div class="divider mt-2 mb-2"></div>
            <div class="d-flex">
              <div class="pt-1">
                <h5 data-activate="question-1" class="font-600">Contribution Amount: USD {{farming.contribution_amount}}</h5>
              </div>
            </div>
            <div class="divider mt-2 mb-2"></div>
            <div class="d-flex">
              <div class="pt-1">
                <h5 data-activate="question-2" class="font-600">Participants: {{farming.number}} members</h5>
              </div>
            </div>
            <div class="divider mt-2 mb-2"></div>
            <div class="d-flex">
              <div class="pt-1">
                <h5 data-activate="question-3" class="font-600">Started: {{formatDate(farming.created_at)}}</h5>
              </div>
            </div>
            <div v-if="!joined" class="container">
              <div class="col-md-12 text-center">
                <button @click="joinFarmingProject(farming)" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900">Join Project</button>
              </div>
            </div>
            <div v-else-if="joined" class="container">
              <div class="col-md-12 text-center">
                <router-link :to="'/chat/projects/'+farming.id" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900">Start Chat</router-link>
              </div>
            </div>
            <div v-else-if="loading" class="container">
              <mushonga></mushonga>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
import global from "@/mixins/global";
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import axios from "axios";
export default {
  mixins: [global],
  mounted() {
    this.joined = false
    this.fetchRoundDetails()
  },
  name: "SingleFarmingProject",
  components: {FooterBar, PageAppBar},
  data(){
    return {
      title: "Farming Project"+this.$route.params.id,
      farming:{},
      loading: false
    }
  },
  methods: {
    fetchRoundDetails(){
      this.loading = true
      axios.get(this.base_url+"farming/"+this.$route.params.id, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
        this.farming = response.data.data
        this.title = this.farming.project
        this.loading = false
      }).catch(error=>{
        this.error = error
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>

</style>